import { Link } from 'react-router-dom';
import LogoGradiente from '@/assets/Logo gradiente.svg';
import AdminIcon from '@/assets/settings.svg';

interface HeaderProps {
  onAdminClick?: () => void;
}

export function Header({ onAdminClick }: HeaderProps) {
  return (
    <header className="sticky top-0 z-30 w-full border-b border-secondary/10 bg-white/90 shadow-sm backdrop-blur-md">
      <div
        className="h-1 bg-gradient-to-r from-primary via-[#ba2532] to-secondary"
        aria-hidden
      />

      <div className="mx-5 flex h-[72px] items-center justify-between md:mx-10 md:h-[80px]">
        <div className="flex min-w-0 items-center gap-3 md:gap-4">
          <Link
            to="/home"
            className="group shrink-0 rounded-xl p-1 transition duration-300 hover:bg-secondary/[0.04]"
          >
            <img
              src={LogoGradiente}
              alt="JEVIS"
              className="h-10 w-auto transition duration-300 group-hover:scale-[1.03] md:h-12"
            />
          </Link>

          <div className="min-w-0 border-l border-secondary/10 pl-3 md:pl-4">
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/90">
              JEVIS
            </p>
            <h1 className="truncate text-base font-extrabold tracking-tight text-secondary md:text-xl">
              <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                Business Analyzer
              </span>
            </h1>
            <p className="mt-0.5 hidden truncate text-xs text-secondary/60 sm:block">
              Gestione lead e task settimanali
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onAdminClick}
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-secondary/10 bg-white text-secondary shadow-sm transition duration-200 hover:border-primary/25 hover:bg-primary/5 hover:shadow-md"
          aria-label="Apri menu impostazioni"
        >
          <img src={AdminIcon} alt="" className="h-5 w-5" aria-hidden />
        </button>
      </div>
    </header>
  );
}
